<button class="btn btn-help" *ngIf="!isMobile" (click)="goToHelp()">Help</button>


<app-change-password />


<!-- Desktop -->
<app-offer-banner [showAsBar]="true" link="/order-flow" *ngIf="isDesktop"/>
<div id="layoutHome" class="web-center" *ngIf="isDesktop">
    <div class="adaptiveImgHeight">
        <div class="d-flex">
            <div class="col-md-12 adaptiveImgHeight">
                <div class="imgMain" style="width: 100%;">
                    <video autoplay loop [muted]="'muted'" playsinline style="height: 100%; width: 100%; object-fit: cover;">
                        <source src="assets/images/Banner 1300x450 v4 - short 24 sec.mp4">
                    </video>
                </div>
                <div class="overlay adaptiveImgHeight">
                    <div class="container">
                        <div class="textbox">
                            <div class="title-container mb-5">
                                <span class="over-title">eat to</span>
                                <span class="title">PERFORM, TRANSFORM,<br/>
                                                    & ACHIEVE BEYOND LIMITS
                                </span>
                                <div class="pt-4">
                                    <div class="loop-box">
                                        <p class="loop-item">Crafted by Master Chefs</p>
                                        <p class="loop-item">Trusted by Athletes</p>
                                        <p class="loop-item">Backed by Science</p>
                                    </div>
                                </div>
                            </div>
                            <app-orange-button (action)="goToPlan()" />

                            <p class="bottom-text">
                                Rated #1 by Elite Athletes and Everyday Achievers
                            </p>
                            <app-trustpilot-card />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <app-how-it-works />

    <div class="card-extra p-0 pt-70">
        <div class="mt-5 web-center container loghi-box">
            <h3 class="p-title-2 p-title-1-as-seen pt-40 pb-40">As Seen In</h3>
            <app-images-loghi />
        </div>

        <app-current-menu-slider />

        <div class="what-makes-wrapper">
            <app-what-makes></app-what-makes>
        </div>

        <div class="features-box p-80">
            <div class="container">
                <p class="mt-3 p-title-2" style="margin-bottom: 80px;">What Makes NutriGenic Your Perfect Health Partner?</p>
                <div class="row justify-content-around my-5 responsiveFont" style="color: #2C2C30; position: relative;">
                    <div class="features-overlay-top"
                         *ngIf="!isHover(6) && !isHover(7) && !isHover(8) && !isHover(1) && !isHover(2) && !isHover(3) && !isHover(4)">
                        <span class="features-description">
                            Hit your goals faster with portion-controlled meals that make overeating impossible and under-fueling a thing of the past.
                        </span>
                    </div>
                    <div class="features-overlay-top"
                         *ngIf="!isHover(5) && !isHover(7) && !isHover(8) && !isHover(1) && !isHover(2) && !isHover(3) && !isHover(4)">
                        <span class="features-description">
                            We do the planning, shopping, and cooking—so you can focus on living.
                        </span>
                    </div>
                    <div class="features-overlay-top"
                         *ngIf="!isHover(5) && !isHover(6) && !isHover(8) && !isHover(1) && !isHover(2) && !isHover(3) && !isHover(4)">
                        <span class="features-description">
                            We are dedicated to offering halal-certified food, adhering to Islamic dietary laws with an unwavering commitment to purity and quality.
                        </span>
                    </div>
                    <div class="features-overlay-top"
                         *ngIf="!isHover(5) && !isHover(6) && !isHover(7) && !isHover(1) && !isHover(2) && !isHover(3) && !isHover(4)">
                        <span class="features-description">
                            With over 80+ meals to choose from every month, enjoy fresh, exciting options without ever repeating a meal.
                        </span>
                    </div>
                    <div class="user-icon col-md-3 col-xl-2 ing-icon" style="cursor: pointer;"
                         [class]="isHover(1) ? 'opacity_full' : 'opacity_null'"
                         (mouseenter)="mouseEnter(1)"
                         (mouseleave)="mouseLeave()">
                        <img src="assets/images/features/100-real.svg" alt="100% Real, Whole Foods">
                        <div class="pb-3 web-center">
                            <span class="">100% Real,<br/> Whole Foods</span>
                        </div>
                    </div>
                    <div class="user-icon col-md-3 col-xl-2" style="cursor: pointer;"
                         [class]="isHover(2) ? 'opacity_full' : 'opacity_null'"
                         (mouseenter)="mouseEnter(2)"
                         (mouseleave)="mouseLeave()">
                        <img src="assets/images/features/crafted-by-chefs.svg" alt="User Icon">
                        <div class="pb-3 web-center">
                            <span class="">Crafted by Chefs</span>
                            <br />
                            <span class="">Backed by Science</span>
                        </div>
                    </div>
                    <div class="user-icon col-md-3 col-xl-2" style="cursor: pointer;"
                         [class]="isHover(3) ? 'opacity_full' : 'opacity_null'"
                         (mouseenter)="mouseEnter(3)"
                         (mouseleave)="mouseLeave()">
                        <img src="assets/images/features/0-artificial-ingredients.svg" alt="Zero Artificial Ingredients or UPFs">
                        <div class="pb-3 web-center">
                            <span class="">Zero Artificial</span>
                            <br />
                            <span class="">Ingredients or UPFs</span>
                        </div>
                    </div>
                    <div class="user-icon col-md-3 col-xl-2" style="cursor: pointer;"
                         [class]="isHover(4) ? 'opacity_full' : 'opacity_null'"
                         (mouseenter)="mouseEnter(4)"
                         (mouseleave)="mouseLeave()">
                        <img src="assets/images/features/packed-protein-perfeclty-balanced.svg" alt="Packed with 40g+, 40g+ Protein">
                        <div class="pb-3 web-center">
                            <span class="">Packed with 40g+</span>
                            <br />
                            <span class="">40g+ Protein</span>
                        </div>
                    </div>
                </div>
                <div class="row justify-content-around mb-5 responsiveFont " style="color: #2C2C30;">
                    <div class="features-overlay"
                         *ngIf="!isHover(2) && !isHover(3) && !isHover(4) && !isHover(5) && !isHover(6) && !isHover(7) && !isHover(8)">
                        <span class="features-description">
                        Forget ultra-processed junk. Our meals are made entirely from clean,
                        whole ingredients—just real food that fuels real results.</span>
                    </div>
                    <div class="features-overlay"
                         *ngIf="!isHover(1) && !isHover(3) && !isHover(4) && !isHover(5) && !isHover(6) && !isHover(7) && !isHover(8)">
                        <span class="features-description">
                            Gourmet flavor meets elite-level nutrition.<br/>
                            Our meals are built by culinary pros and signed off by performance nutritionists.
                        </span>
                    </div>
                    <div class="features-overlay"
                         *ngIf="!isHover(1) && !isHover(2) && !isHover(4) && !isHover(5) && !isHover(6) && !isHover(7) && !isHover(8)">
                        <span class="features-description">
                            No additives. No preservatives.<br/>
                            No shortcuts. Just pure, powerful fuel for your body.
                        </span>
                    </div>
                    <div class="features-overlay"
                         *ngIf="!isHover(1) && !isHover(2) && !isHover(3) && !isHover(5) && !isHover(6) && !isHover(7) && !isHover(8)">
                        <span class="features-description">
                            Over 40g of protein in every meal. Engineered to crush hunger, power performance, and build lean muscle—without the calorie overload.
                        </span>
                    </div>
                    <div class="user-icon col-md-3 col-xl-2" style="cursor: pointer;" (mouseenter)="mouseEnter(5)"
                         (mouseleave)="mouseLeave()">
                        <img src="assets/images/features/target-nutrition.svg" alt="User Icon"
                             [class]="isHover(5) ? 'opacity_full' : 'opacity_null'">
                        <div class="pb-3 web-center" [class]="isHover(5) ? 'opacity_full' : 'opacity_null'">
                            <span class="">Targeted Nutrition</span>
                            <br />
                            <span class="">That Delivers </span>
                        </div>
                    </div>
                    <div class="user-icon col-md-3 col-xl-2" style="cursor: pointer;"
                         [class]="isHover(6) ? 'opacity_full' : 'opacity_null'" (mouseenter)="mouseEnter(6)"
                         (mouseleave)="mouseLeave()">
                        <img src="assets/images/features/reclaim-your-time.svg" alt="Skip the Mess, Reclaim Your Time">
                        <div class="pb-3 web-center">
                            <span class="">Skip the Mess</span>
                            <br />
                            <span class="">Reclaim Your Time</span>
                        </div>
                    </div>
                    <div class="user-icon col-md-3 col-xl-2" style="cursor: pointer;"
                         [class]="isHover(7) ? 'opacity_full' : 'opacity_null'" (mouseenter)="mouseEnter(7)"
                         (mouseleave)="mouseLeave()">
                        <img src="assets/images/features/halal.svg" alt="Halal Certified">
                        <div class="pb-3 web-center">
                            <span class="">Halal</span>
                            <br />
                            <span class="">Certified</span>
                        </div>
                    </div>
                    <div class="user-icon col-md-3 col-xl-2" style="cursor: pointer;"
                         [class]="isHover(8) ? 'opacity_full' : 'opacity_null'" (mouseenter)="mouseEnter(8)"
                         (mouseleave)="mouseLeave()">
                        <img src="assets/images/features/80-meals-choices.svg" alt="80+ Meal Choices Each Month">
                        <div class="pb-3 web-center">
                            <span class="">80+ Meal Choices EachMonth</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="card-extra pt-40">
            <div class="web-center who-made-us-margin">
                <app-elite-athletes />
            </div>

            <div class="web-center">
                <app-orange-button (action)="goToPlan()"></app-orange-button>
            </div>

            <div class="trustbox">
                <app-reviews />
            </div>
        </div>

        <div class="mt-5">
            <app-help-sector></app-help-sector>
        </div>
    </div>
</div>


<app-offer-banner [showAsBar]="true" link="/order-flow" *ngIf="isTablet || isMobile"/>


<!-- Tablet And Mobile -->
<div id="layoutHome" class="web-center" *ngIf="isTablet || isMobile">
    <div class="col-md-12 adaptiveImgHeight">
        <video autoplay loop [muted]="'muted'" playsinline preload="auto"
            style="height: 100%; width: 100%;transform: scale(1.5);transform-origin: top center;"
            *ngIf="isMobile">
            <source src="assets/images/Banner 1080x1080 (inhouse) .mp4">
        </video>
        <video autoplay loop [muted]="'muted'" playsinline preload="auto" style="height: 100%; width: 100%; object-fit: cover;"
            *ngIf="isTablet">
            <source src="assets/images/Banner 1300x450 v4 - short 24 sec.mp4">
        </video>
        <div class="overlay-banner-Tablet"></div>
    </div>
    <div class="title-container p-4 pt-1">
        <p class="title mb-4">
            <span class="text-orange-1" style="font-size: 22px;">EAT TO</span><br/>
            <i>
                PERFORM, TRANSFORM,<br/>
                & ACHIEVE BEYOND LIMITS
            </i>
        </p>
        <span class="sub-title">
            <b *ngIf="isMobile">Simply Exceptional - </b> Crafted by Master Chefs, Trusted by Athletes, and Backed by Science.
        </span>
    </div>
    <app-orange-button (action)="goToPlan()"/>

    <app-trustpilot-card text="Rated #1 by Elite Athletes <br/> and Everyday Achievers" />

    <app-how-it-works />

    <div class="card-extra mt-70 pt-40">
        <div class="loghi-box">
            <p class="mx-1 p-title-2">As Seen In</p>
            <app-images-loghi />
        </div>

        <app-current-menu-slider />

    </div>

    <div class="what-makes-wrapper" [ngClass]="{ 'what-makes-wrapper--compact': isMobile }">
        <app-what-makes></app-what-makes>
    </div>

        <div class="mt-4 p-4 pt-0" *ngIf="isMobile">
            <p class="mx-3 mb-4 p-title-1">What Makes NutriGenic Your Perfect Health Partner?</p>
            <div class="icons-grid my-0">
                <div>
                    <img src="assets/images/features/100-real.svg" alt="100% Real, Whole Foods, Nothing Less">
                    <span>100% Real, Whole Foods</span>
                </div>
                <div>
                    <img src="assets/images/features/crafted-by-chefs.svg" alt="User Icon">
                    <span>Crafted by Chefs Backed by Science</span>
                </div>
                <div>
                    <img src="assets/images/features/0-artificial-ingredients.svg" alt="Zero Artificial Ingredients or UPFs">
                    <span>Zero Artificial Ingredients or UPFs</span>
                </div>
                <div>
                    <img src="assets/images/features/packed-protein-perfeclty-balanced.svg" alt="Packed with 40g+ 40g+ Protein">
                    <span>Packed with 40g+ 40g+ Protein</span>
                </div>

                <div>
                    <img src="assets/images/features/target-nutrition.svg" alt="User Icon">
                    <span>Targeted Nutrition That Delivers </span>
                </div>
                <div>
                    <img src="assets/images/features/reclaim-your-time.svg" alt="Skip the Mess, Reclaim Your Time">
                    <span>Skip the Mess Reclaim Your Time</span>
                </div>
                <div>
                    <img src="assets/images/features/halal.svg" alt="Halal Certified">
                    <span>Halal Certified</span>
                </div>
                <div>
                    <img src="assets/images/features/80-meals-choices.svg" alt="80+ Meal Choices EachMonth" style="width: 65px; height: 65px;">
                    <span>80+ Meal Choices EachMonth</span>
                </div>
            </div>
        </div>


        <div class="mt-5 nutrigenic-points" *ngIf="!isMobile">
            <p class="mt-4 p-title-2">What Makes NutriGenic Your Perfect Health Partner?</p>
            <div class="justify-content-center my-5 responsiveFont" [ngClass]="isTablet ? 'd-flex' : ''"
                 style="color: #2C2C30;">
                <div class="user-icon col-md-3" [class.mb-5]="isMobile">
                    <img src="assets/images/features/100-real.svg" alt="100% Real, Whole Foods, Nothing Less">
                    <div class="pb-3 web-center">
                        <span class="">100% Real, <br/>Whole Foods</span>
                    </div>
                </div>
                <div class="user-icon  col-md-3">
                    <img src="assets/images/features/crafted-by-chefs.svg" alt="User Icon">
                    <div class="pb-3 web-center">
                        <span class="">Crafted by Chefs</span>
                        <br />
                        <span class="">Backed by Science</span>
                    </div>
                </div>
            </div>
            <div class="justify-content-center mb-5 responsiveFont" [ngClass]="isTablet ? 'd-flex' : ''"
                 style="color: #2C2C30;">
                <div class="user-icon col-md-3" [class.mb-5]="isMobile">
                    <img src="assets/images/features/target-nutrition.svg" alt="User Icon">
                    <div class="pb-3 web-center">
                        <span class="">Targeted Nutrition</span>
                        <br />
                        <span class="">That Delivers </span>
                    </div>
                </div>
                <div class="user-icon col-md-3">
                    <img src="assets/images/features/reclaim-your-time.svg" alt="Skip the Mess, Reclaim Your Time">
                    <div class="pb-3 web-center">
                        <span class="">Skip the Mess</span>
                        <br />
                        <span class="">Reclaim Your Time</span>
                    </div>
                </div>
            </div>
            <div class="justify-content-center mb-5 responsiveFont" [ngClass]="isTablet ? 'd-flex' : ''"
                 style="color: #2C2C30;">
                <div class="user-icon col-md-3" [class.mb-5]="isMobile">
                    <img src="assets/images/features/0-artificial-ingredients.svg" alt="Zero Artificial Ingredients or UPFs">
                    <div class="pb-3 web-center">
                        <span class="">Zero Artificial</span>
                        <br />
                        <span class="">Ingredients or UPFs</span>
                    </div>
                </div>
                <div class="user-icon col-md-3">
                    <img src="assets/images/features/packed-protein-perfeclty-balanced.svg" alt="Packed with 40g+, 40g+ Protein.">
                    <div class="pb-3 web-center">
                        <span class="">Packed with 40g+</span>
                        <br />
                        <span class="">40g+ Protein</span>
                    </div>
                </div>
            </div>

            <div class="justify-content-center mb-5 responsiveFont" [ngClass]="isTablet ? 'd-flex' : ''"
                 style="color: #2C2C30;">
                <div class="user-icon col-md-3" [class.mb-5]="isMobile">
                    <img src="assets/images/features/halal.svg" alt="Halal Certified">
                    <div class="pb-3 web-center">
                        <span class="">Halal</span>
                        <br />
                        <span class="">Certified</span>
                    </div>
                </div>
                <div class="user-icon col-md-3">
                    <img src="assets/images/features/80-meals-choices.svg" alt="80+ Meal Choices Each Month">
                    <div class="pb-3 web-center">
                        <span class="">80+ Meal Choices</span>
                        <br />
                        <span class="">EachMonth</span>
                    </div>
                </div>
            </div>
        </div>

        <div class="card-extra mt-80 pt-40 pb-20 pr-30 pl-30">
            <app-elite-athletes />
        </div>

        <div class="web-center">
            <app-orange-button (action)="goToPlan()"></app-orange-button>
        </div>

        <div class="fade-div trustbox mt-80">
            <app-reviews />
        </div>

        <div class="mt-4">
            <app-help-sector />
        </div>
    </div>



<app-offer-banner link="/order-flow"/>



